import { useFetch } from "../data/useFetcher"
import { useOrganization } from "./useOrganization"

export const useGetPro = () => {

    const org = useOrganization();
    const api = useGetProApi();

    return {
        clicked: async () => {
            console.log("orgid:", org.currentOrganization?.id, org.currentOrganization?.name);
            const res = await api.clicked(org.currentOrganization?.id ?? "");
            await org.loadOrganizations();
        }
    }
}


export const useGetProApi = () => {

    const f = useFetch();

    return {
        clicked: async (organizationId: string): Promise<boolean> => {
            const url = "/api/organizations/" + organizationId + "/makepremium";
            return await f.patch(url, {});
        }
    }
}